import { DebugService } from './shared/services/debug.service.js';
import { SessionService } from './core/services/session/session.service.js';
import { Router } from './router.js';
import { isObjectEmpty } from './core/services/utils/common.utils.js';
import { REFI_ESIGN_CONST } from '../constants/app.constants.js';
import { HostAppEventsService } from './shared/services/host-app-events.service.js';
import { getIsV2Routing } from './shared/services/routing-v2.service.js';
// import { isObjectEmpty } from './core/services/utils/common.utils.js';

class _AppService {
  constructor() {
    this.isPerf = false;
    let testingParam = '';
    if (document?.location) {
      testingParam = new URL(document.location)?.searchParams?.get('testing');
      this.isPerf = testingParam === 'lighthouse' && !REFI_ESIGN_CONST.isProdEnv;
    }
    this.session = SessionService.session || {};
    if (this.isPerf) {
      this.session = SessionService.mockSession;
    }
    this.debug = new DebugService('AppService');
    this._state = {
      appStatusId: this.session?.currentApp?.appStatusId,
      statFlag: this.session?.currentApp?.statFlag,
    };
    this._customerDetails = {
      firstName: this.session?.currentApp?.firstName,
      experiences: this.session?.customerExperiences,
    };
    this._status = '';
  }

  get status() {
    this.debug.log('getting status', this._status);
    return this._status;
  }

  get state() {
    return this._state;
  }

  get borrowerFirstName() {
    return this._customerDetails?.firstName?.trim();
  }

  get customerExperiences() {
    return this._customerDetails?.experiences;
  }

  updateState({ appStatusId = SessionService.session?.currentApp?.appStatusId, statFlag = SessionService.session?.currentApp?.statFlag, isETitle = this._state?.isETitle, stateCode = this._state?.stateCode } = {}, updateRoute = true) {
    this.debug.log('updateState called with', {
      appStatusId,
      statFlag,
      isETitle,
    });
    this._state = { appStatusId, statFlag, isETitle, stateCode };
    SessionService.session = { appStatusId, statFlag, isETitle, stateCode };

    if (updateRoute) {
      this.updateRoute(this.state);
    }
  }

  updateRoute(state) {
    this.debug.log(`routing with state: ${JSON.stringify(state)}`);
    if (!isObjectEmpty(state)) {
      const isETitle = state?.isETitle || false;

      if (isETitle) {
        this._status = 'e-title';
      } else {
        this._status = 'e-sign';
      }

      if (getIsV2Routing()) {
        HostAppEventsService.sendNextStepEvent(this._status);
      } else {
        Router.goTo(`${this._status}`);
        Router.sendStateChangedEvent(`${this._status}`);
      }
    } else {
      this.debug.log('Potential problem with application state: state is empty');
    }
  }
}

export const AppService = new _AppService();
